import React from 'react'
import { FormControl, TextField, Grid, Box,Button, MenuItem, CardContent, Card } from '@mui/material';
import { DownloadCloud } from 'react-feather';

import { CustomAutocomplete } from 'common'

export const PaymentsForm = ({ useFetchInit }) => {
    
    const {
        //------------- Generales
        //------------- globalStates
        // globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    
    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { FormTransaction } = Forms
    const { formState, onInputChange, onSelectSearchChange } = FormTransaction
    
    // ------------------------------------------------ FetchData
    const { fetchAllBanks } = FetchData
    const { banks } = fetchAllBanks
    
    // ------------------------------------------------ Actions
    const {
        onSubmitForm,
        handleClickHideForm,
        handleClickDownloadImage,
    } = Actions

    // const { dataRequest } = dataModal
        
    return (
        <div className='content'>
            <div className="pt-4"></div>
            <Card style={{zIndex:'1'}}>
                <CardContent>
                    <form onSubmit={(e) => onSubmitForm(e)}>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_fecha">* Fecha</label>
                                    <TextField
                                        id="movimiento_fecha"
                                        name="movimiento_fecha"
                                        value={formState.movimiento_fecha}
                                        onChange={onInputChange}
                                        // label='Fecha'
                                        size='small'
                                        type="date"
                                        variant='filled'
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: true
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_tipo">* Tipo</label>
                                    <TextField
                                        id="movimiento_tipo"
                                        name="movimiento_tipo"
                                        // label="Tipo de movimiento"
                                        value={formState.movimiento_tipo}
                                        onChange={onInputChange}
                                        select
                                        size="small"
                                        variant='filled'
                                        // lable="Selecciona una opción"
                                        hiddenLabel
                                        InputProps={{ 
                                            readOnly: true 
                                        }}
                                    >
                                        <MenuItem value=''>-- Selecciona una opción --</MenuItem>
                                        <MenuItem value='DEPOSITO'>DEPOSITO</MenuItem>
                                        <MenuItem value='EFECTIVO'>EFECTIVO</MenuItem>
                                    </TextField>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <div className="pt-2"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_monto">* Monto</label>
                                    <TextField
                                        id="movimiento_monto"
                                        name="movimiento_monto"
                                        value={formState.movimiento_monto}
                                        onChange={onInputChange}
                                        // label='Monto a recibir'
                                        size='small'
                                        type="number"
                                        min="0"
                                        step="0.01"
                                        variant='filled'
                                        hiddenLabel
                                        InputProps={{ 
                                            readOnly: true
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_moneda">* Moneda</label>
                                    <TextField
                                        id="movimiento_moneda"
                                        name="movimiento_moneda"
                                        // label="Moneda"
                                        value={formState.movimiento_moneda}
                                        onChange={onInputChange}
                                        select
                                        size="small"
                                        variant='filled'
                                        // lable="Selecciona una opción"
                                        hiddenLabel
                                        InputProps={{ 
                                            readOnly: true
                                        }}
                                    >
                                        <MenuItem value=''>-- Selecciona una opción --</MenuItem>
                                        <MenuItem value='QUETZAL'>QUETZAL</MenuItem>
                                        <MenuItem value='DOLAR'>DOLAR</MenuItem>
                                    </TextField>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_tipo_cambio">* Tipo de Cambio</label>
                                    <TextField
                                        id="movimiento_tipo_cambio"
                                        name="movimiento_tipo_cambio"
                                        value={formState.movimiento_tipo_cambio}
                                        onChange={onInputChange}
                                        // label='Tipo de cambio'
                                        size='small'
                                        type="number"
                                        min="0"
                                        step="0.01"
                                        variant='filled'
                                        hiddenLabel
                                        InputProps={{ 
                                            readOnly: true
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <div className="pt-2"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_quetzales">* Total en Quetzales</label>
                                    <TextField
                                        id="movimiento_quetzales"
                                        name="movimiento_quetzales"
                                        value={formState.movimiento_quetzales}
                                        onChange={onInputChange}
                                        // label='Total en quetzales'
                                        size='small'
                                        type="number"
                                        min="0"
                                        step="0.01"
                                        variant='filled'
                                        hiddenLabel
                                        InputProps={{ 
                                            readOnly: true
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_dolares">* Total en Dolares</label>
                                    <TextField
                                        id="movimiento_dolares"
                                        name="movimiento_dolares"
                                        value={formState.movimiento_dolares}
                                        onChange={onInputChange}
                                        // label='Total en dolares'
                                        size='small'
                                        type="number"
                                        min="0"
                                        step="0.01"
                                        variant='filled'
                                        hiddenLabel
                                        InputProps={{ 
                                            readOnly: true
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <div className="pt-2"></div>
                        
                        
                        {/* ------------------------------------------------- */}
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <label htmlFor="dowload-boleta">* Boleta de Deposito</label>
                                    <Button
                                        startIcon={<DownloadCloud/>}
                                        color='success'
                                        variant="contained"
                                        onClick={(event) => handleClickDownloadImage( formState.boleta_foto_originalname, formState.boleta_foto_path )}
                                        sx={{textDecoration: 'none', paddingTop: 1}}
                                    >Descargar</Button>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <label htmlFor="idbanco">* Banco</label>
                                    <CustomAutocomplete 
                                            customId="idbanco"
                                            customName="idbanco"
                                            customValue={formState.idbanco}
                                            customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idbanco', value: value.value }})}
                                            customPlaceholder='Seleccionar banco'
                                            customOptions={
                                                banks.map(({ idbanco, nombre }) => ({
                                                    value: idbanco,
                                                    name: nombre
                                                }))
                                            }
                                            customDisableClearable={true}
                                            customDisabled={true}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                <label htmlFor="boleta">No. Referencia ACH</label>
                                    <TextField
                                        id='aprobacion_referencia_ach'
                                        name='aprobacion_referencia_ach'
                                        value={ formState.aprobacion_referencia_ach }
                                        onChange={ onInputChange }
                                        size="small"
                                        hiddenLabel
                                        placeholder='No. Referencia ACH'
                                        type='number'
                                        variant= 'outlined'
                                        InputProps={{
                                            readOnly: false
                                        }}
                                    />   
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>   
                                <FormControl fullWidth>
                                    <label htmlFor="aprobacion_check">* Aprobacion</label>
                                    <TextField
                                        id="aprobacion_check"
                                        name="aprobacion_check"
                                        // label="Moneda"
                                        value={formState.aprobacion_check}
                                        onChange={onInputChange}
                                        select
                                        size="small"
                                        // lable="Selecciona una opción"
                                        hiddenLabel
                                        variant='outlined'
                                        InputProps={{ readOnly: false }}
                                    >
                                        <MenuItem value=''>-- Selecciona una opción --</MenuItem>
                                        <MenuItem value='APROBADO'>APROBADO</MenuItem>
                                        <MenuItem value='PENDIENTE'>PENDIENTE</MenuItem>
                                        <MenuItem value='RECHAZADO'>RECHAZADO</MenuItem>
                                    </TextField>
                                </FormControl>
                            </Grid>     
                        </Grid>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>   
                                <FormControl fullWidth>
                                <label htmlFor="aprobacion_observaciones">Observaciones</label>
                                    <TextField
                                        id='aprobacion_observaciones'
                                        name='aprobacion_observaciones'
                                        value={ formState.aprobacion_observaciones }
                                        onChange={ onInputChange }
                                        size="small"
                                        multiline
                                        rows={5}
                                        hiddenLabel
                                        placeholder='Observaciones'
                                        type='text'
                                        variant= 'outlined'
                                        InputProps={{
                                            readOnly: false
                                        }}
                                    />   
                                </FormControl>
                            </Grid>   
                        </Grid>
                        {/* ------------------------------------------------- */}

                        <div className="pt-4"></div>
                        <Box pt={4}>
                            <Grid container spacing={2} justifyContent="flex-end">
                                <Grid item>
                                    <Button
                                        style={{background: "#47c4c7"}}
                                        variant="contained"
                                        type="submit"
                                    >
                                        Guardar
                                    </Button>
                                    &nbsp;
                                    <Button
                                        color='warning'
                                        variant="contained"
                                        type="button"
                                        onClick={handleClickHideForm}
                                    >
                                        Cancelar
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </CardContent>
            </Card>
            <div className="pt-4"></div>
        </div>
    )

}
